import React from 'react'
import { Badge, Icon } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const STATUSES = {
  new: {
    icon: 'status new',
    color: 'Label-GU-Primary',
    bgColor: 'Background-Quaternary',
    label: 'services::account_list.statuses.new',
  },
  pending: {
    icon: 'status pause',
    color: 'Label-Notice',
    bgColor: 'Background-Notice',
    label: 'services::account_list.statuses.pending',
  },
  verified: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'services::account_list.statuses.verified',
  },
  declined: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'services::account_list.statuses.declined',
  },
  block: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'services::account_list.statuses.block',
  },
  deleted: {
    icon: 'trash',
    color: 'Label-Fifth',
    bgColor: 'Background-Quaternary',
    label: 'services::account_list.statuses.deleted',
  },
  token_expired: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'services::account_list.statuses.token_expired',
  },
  error: {
    icon: 'status error',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'services::account_list.statuses.error',
  },
  auto_replenishment_enabled_short: {
    icon: 'status done',
    color: 'Label-Confirm',
    bgColor: 'Background-Quaternary',
    label: 'services::account_list.auto_replenish_status_short.on',
  },
  auto_replenishment_enabled: {
    icon: 'done',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'services::account_list.auto_replenish_status.on',
  },
  auto_replenishment_disabled_short: {
    icon: 'close',
    color: 'Label-Fifth',
    bgColor: 'Background-Quaternary',
    label: 'services::account_list.auto_replenish_status_short.off',
  },
  auto_replenishment_disabled: {
    icon: 'status warning',
    color: 'Label-Tertiary',
    bgColor: 'Background-Error',
    label: 'services::account_list.auto_replenish_status.off',
  },
  advertiser_info_not_full_filled: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'services::account_list.advertiser_info_not_full_filled.tooltip.text',
  },
  moderation: {
    icon: 'status pause',
    color: 'Label-Notice',
    bgColor: 'Background-Notice',
    label: 'services::account_list.statuses.moderation',
  },
  'creation-fee-awaits': {
    icon: 'time-clock',
    color: 'Label-Notice',
    bgColor: 'Background-Notice',
    label: 'services::account_list.statuses.creation_fee_awaits',
  },
}

export const StatusBadge = ({ status = null, ...rest }) => {
  const currentStatus = STATUSES?.[status]
  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, label, bgColor, color } = currentStatus

  return (
    <Badge
      {...rest}
      bgColor={bgColor}
      color={color}
      startIcon={
        <Icon
          color={color}
          name={icon}
          width={16}
        />
      }
    >
      {t(label)}
    </Badge>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
